import { z } from 'zod';

import { useChannelSchema } from './channel-schema';
import { useJobDetailsSchema } from './job-details-schema';
import { usePoolSchema } from './pool-schema';

/**
 * Main hook for creating the complete validation schema for job posting form
 *
 * Combines:
 * - Channel validation (budgets, dates, allocations, budget type)
 * - Job details validation (title, description)
 */
export function useValidationSchema() {
  return z.object({
    channels: useChannelSchema(),
    jobDetails: useJobDetailsSchema(),
    pool: usePoolSchema().optional(),
  });
}
